import type { ModalLook } from "./look";

export type ResolvedColors = {
  acceptBg: string;
  acceptText: string;
  /** The "accept selected" button. */
  acceptShortcutBg: string;
  acceptShortcutText: string;
  acceptShortcutBorder: string;
  declineBg: string;
  declineText: string;
  declineBorder: string;
  link: string;
  heading: string;
  text: string;
  font: string;
  borderRadius: string;
  primaryColor: string;
  secondaryColor: string;
};

const asString = (value: string | number | undefined, fallback: string): string =>
  value === undefined ? fallback : String(value);

/**
 * The colours the age gate, guardian form and verification screen paint
 * with, read from the notice's resolved look so they follow the console
 * palette and the host's `settings` like the notice itself does.
 */
export function colorsFromLook(look: ModalLook): ResolvedColors {
  const { acceptAll, acceptSelected, decline, base } = look.buttons;
  return {
    acceptBg: asString(acceptAll.backgroundColor, look.accentColor),
    acceptText: asString(acceptAll.color, "#ffffff"),
    acceptShortcutBg: asString(acceptSelected.backgroundColor, "#ffffff"),
    acceptShortcutText: asString(acceptSelected.color, look.accentColor),
    acceptShortcutBorder: asString(acceptSelected.borderColor, look.accentColor),
    declineBg: asString(decline.backgroundColor, "#ffffff"),
    declineText: asString(decline.color, "#000000"),
    declineBorder: asString(decline.borderColor, "#d0d5dd"),
    link: look.linkColor,
    heading: look.headingColor,
    text: look.textColor,
    font: "inherit",
    borderRadius: asString(base.borderRadius, "8px"),
    primaryColor: asString(acceptAll.backgroundColor, look.accentColor),
    secondaryColor: look.linkColor,
  };
}
